// Central office contact constants & helpers
export const OFFICE = {
  name: "Maître Boudiaf Aimad Eddine",
  address: "City RTT 04, Dély Ibrahim, Alger",
  phoneFixed: "028 36 30 41",
  phoneFixedTel: "+213028363041",
  phoneMobile: "+213 676 76 39 34",
  phoneMobileTel: "+213676763934",
  whatsappNumber: "213676763934",
  email: "opnotariale.boudiaf@gmail.com",
  mapQuery: "City RTT 04, Dély Ibrahim, Alger",
};

export function whatsappUrl(prefilledMessage = "") {
  const text = encodeURIComponent(prefilledMessage || "");
  return `https://wa.me/${OFFICE.whatsappNumber}${text ? `?text=${text}` : ""}`;
}

export function telUrl(fixed = false) {
  return `tel:${fixed ? OFFICE.phoneFixedTel : OFFICE.phoneMobileTel}`;
}

export function mailUrl(subject = "") {
  const s = subject ? `?subject=${encodeURIComponent(subject)}` : "";
  return `mailto:${OFFICE.email}${s}`;
}

export function mapUrl() {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(OFFICE.mapQuery)}`;
}

export function mapEmbedUrl() {
  return `https://www.google.com/maps?q=${encodeURIComponent(OFFICE.mapQuery)}&output=embed`;
}
